<div class="dialog-header">
  <div class="header-title">
    <span class="header-span">Activity Editor</span>
  </div>

  <div class="buttons-block">
    <button class="header-button send-button" mat-button (click)="saveDict()" [disabled]="saveLoading"
            [ngClass]="{'disabled-button': saveLoading}">
      <span *ngIf="!saveLoading">Save</span>
      <lib-mini-progress-spinner *ngIf="saveLoading"></lib-mini-progress-spinner>
    </button>
  </div>

  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="inputs-block">
    <div class="input-block">
      <div class="input-label">Name:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}"
               [disabled]="true" [(ngModel)]="tempActivity.name">
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Title:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}"
               [disabled]="saveLoading" [(ngModel)]="tempActivity.title">
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">ShortCode:</div>

      <div class="email-input-text">
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}"
               [disabled]="saveLoading" [(ngModel)]="tempActivity.shortCode">
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Roles:</div>

      <div class="email-input-text">
        <p-multiSelect [ngModelOptions]="{standalone: true}" [options]="allRolesSting" [(ngModel)]="selectedRolesSting"
                       defaultLabel="Roles" [filter]="false" [required]="true">
        </p-multiSelect>
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Alert Overlapping:</div>

      <div class="email-input-text">
        <p-inputSwitch [ngModelOptions]="{standalone: true}" [(ngModel)]="tempActivity.preventOverlapping">
        </p-inputSwitch>
      </div>
    </div>

    <div class="input-block">
      <div class="input-label">Activity Time:</div>

      <div class="email-input-text">
        <div class="time-row-block">
          From:
          <p-calendar appendTo="body" [ngModelOptions]="{standalone: true}"
                      hourFormat="12" [stepMinute]="15" [panelStyleClass]="'time-edit-panel'"
                      [(ngModel)]="tempStartTime" [timeOnly]="true"></p-calendar>
          To:
          <p-calendar appendTo="body" [ngModelOptions]="{standalone: true}"
                      hourFormat="12" [stepMinute]="15" [panelStyleClass]="'time-edit-panel'"
                      [(ngModel)]="tempEndTime" [timeOnly]="true"></p-calendar>
        </div>
      </div>
    </div>
    <div class="input-block duration-block">
      <div class="input-label">Classic Durations:</div>
      <app-activity-duration-edit-block [wa]="false" [activity]="tempActivity" [displayComplexity]="true"></app-activity-duration-edit-block>
      <div class="input-label">Workload Durations:</div>
      <app-activity-duration-edit-block [wa]="true" [activity]="tempActivity" [displayComplexity]="true"></app-activity-duration-edit-block>
    </div>

    <div class="input-block">
      <div class="input-label">Color:</div>

      <div class="email-input-text color-picker-input">

        <div class="color-block-picker">
          <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
                 [ngModelOptions]="{standalone: true}"
                 [disabled]="saveLoading" [(ngModel)]="tempActivity.color">

          <p-colorPicker class="arrow-input additional-colorpicker" [(ngModel)]="tempActivity.color" [disabled]="true"
                         [ngModelOptions]="{standalone: true}" appendTo="cdk-overlay-container">
          </p-colorPicker>
        </div>


        <p-colorPicker class="arrow-input" [(ngModel)]="tempActivity.color" [disabled]="saveLoading" [inline]="true"
                       [ngModelOptions]="{standalone: true}" appendTo="cdk-overlay-container">
        </p-colorPicker>
      </div>
    </div>


  </div>
</div>
